module.exports = __webpack_public_path__ + "static/img/innovation04.cc49597.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/innovation04.png
// module id = K3pm
// module chunks = 1